// Auto-generated by semantic-release - DO NOT EDIT
export const VERSION_INFO = {
  version: '1.79.1',
  buildDate: '2026-11-03T21:54:25.079Z',
  commitSha: 'af9acdd',
} as const

export type VersionInfo = typeof VERSION_INFO
